// extracted by mini-css-extract-plugin
export default {"container":"App_container__+M2TC","loaderContainer":"App_loaderContainer__w8ogF","loader":"App_loader__9f32A"};